'use strict';

var execute = function (options) {
  var generator = new options.type(options);
  return generator.execute();
};

export default execute;
